var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 12,
    viewBox: "0 0 58 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 12,
    fill: "#C5C5C5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "axiom ai insights logo"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -154.5,
    y: -20.5,
    width: 232,
    height: 128,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fill=Yes"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206.167,
    height: 30,
    transform: "translate(-139 -9)",
    fill: "url(#paint0_linear_116_9906)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "frame",
    clipPath: "url(#clip0_116_9906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "axiom-black 1 logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.71676 9.54101H4.3658L3.83455 11.2704H0.933105L4.77445 0.729248H7.30811L11.1495 11.2704H8.24801L7.71676 9.54101ZM7.06291 7.35866L6.04128 4.02337L5.01964 7.35866H7.06291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.8514 0.729248H20.9163L18.0557 5.95866L20.998 11.2704H17.8922L16.2576 7.85278L14.623 11.2704H11.5581L14.5004 5.95866L11.6398 0.729248H14.7047L16.2985 4.10572L17.8922 0.729248H17.8514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.897 11.2704V0.729248H24.5532V11.2704H21.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.3202 8.96462C33.9115 9.74697 33.3803 10.3646 32.6856 10.7764C31.9909 11.1881 31.1736 11.394 30.2745 11.394C29.3755 11.394 28.5582 11.1881 27.8635 10.7764C27.1688 10.3646 26.5966 9.74697 26.2289 8.96462C25.8202 8.18227 25.6567 7.23521 25.6567 6.2058V5.83521C25.6567 4.76462 25.8611 3.85874 26.2289 3.07638C26.6375 2.29403 27.1688 1.67638 27.8635 1.26462C28.5582 0.852855 29.3755 0.646973 30.2745 0.646973C31.1736 0.646973 31.9909 0.852855 32.6856 1.26462C33.3803 1.67638 33.9524 2.29403 34.3202 3.07638C34.7289 3.85874 34.8923 4.8058 34.8923 5.83521V6.2058C34.8923 7.27638 34.688 8.18227 34.3202 8.96462ZM31.664 3.5705C31.337 3.07638 30.8875 2.78815 30.2745 2.78815C29.0077 2.78815 28.3947 3.77638 28.3947 5.79403V6.2058C28.3947 7.19403 28.5582 7.93521 28.8851 8.42933C29.212 8.92344 29.6615 9.21168 30.3154 9.21168C30.9692 9.21168 31.3779 8.96462 31.7048 8.42933C32.0317 7.89403 32.1952 7.15285 32.1952 6.2058V5.79403C32.1952 4.8058 32.0317 4.06462 31.7048 3.5705H31.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M47.2338 11.2704H44.5367V9.29395L44.7819 3.94101L42.3708 11.3116H40.6136L38.2026 3.94101L38.4886 9.29395V11.2704H35.7915V0.729248H39.3059L41.4718 7.72925L43.6377 0.729248H47.1929V11.2704H47.2338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M52.2602 1.26465V2.37641H51.1568V5.29994H49.7266V2.37641H48.6641V1.26465H52.2602ZM56.5511 5.34112V3.81759C56.5102 3.32347 56.5511 2.747 56.5102 2.047H56.4285C56.3059 2.70582 56.1833 3.2823 56.0607 3.77641L55.7746 5.25877H54.4669L54.2626 3.77641C54.2218 3.36465 54.0992 2.66465 54.0174 2.047H53.9357C53.9357 2.66465 53.9357 3.32347 53.8948 3.81759V5.34112H52.5463L52.7506 1.30582H54.9165L54.9982 1.8823C55.0391 2.21171 55.0799 2.54112 55.2025 3.32347C55.2842 2.78818 55.4069 2.37641 55.4886 1.8823L55.6112 1.30582H57.6136L57.777 5.34112H56.4285H56.5511Z",
    fill: "white"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_116_9906",
    x1: 103,
    y1: -8,
    x2: 103.083,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.596116,
    stopColor: "#1E096B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223DC3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_9906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189.167,
    height: 14,
    fill: "white",
    transform: "translate(-130 -1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.bcf8285f5d27a14e930bd8de52db0f26.svg";
export { ForwardRef as ReactComponent };